import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import styles from "./training-search-chat.module.scss";

type TrainingSearchChatAgentProps = {
  parsedContent: any;
};

export default function TrainingSearchChatAgent({
  parsedContent,
}: TrainingSearchChatAgentProps): JSX.Element {
  // Extract answer from finalAnswer array
  // Structure: finalAnswer: ["{\"agent_name\": \"training_search_chat\", \"answer\": \"...\", \"source_courses\": null}"]
  let answer = "";

  try {
    if (
      parsedContent?.finalAnswer &&
      Array.isArray(parsedContent.finalAnswer) &&
      parsedContent.finalAnswer.length > 0
    ) {
      const chatData = JSON.parse(parsedContent.finalAnswer[0]);
      answer = chatData.answer || "";
    }
  } catch (error) {
    console.error("TrainingSearchChatAgent parse error:", error);
  }

  // Fallback to question
  if (!answer && parsedContent?.question) {
    answer = parsedContent.question;
  }

  // Don't render if no answer
  if (!answer) {
    return <></>;
  }

  return (
    <Box className={styles.chatContainer}>
      <Box className={styles.infoBox}>
        <InfoOutlinedIcon sx={{ color: "#00a888", fontSize: 20 }} />
        <Typography className={styles.messageText}>{answer}</Typography>
      </Box>
    </Box>
  );
}
